import { Colors } from '@/common/colors/colors';

const { default: styled } = require('styled-components');

export const Flex = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const Flex2 = styled.div`
	display: flex;
	width: 100%;
	gap: 20px;
	align-items: center;
	margin-top: 20px;
`;

export const Label = styled.label`
	font-size: 20px;
	display: flex;
	padding: 0px 30px;
`;

export const VariantTableWrapper = styled.div`
	margin-top: 30px;
	width: 100%;
	display: flex;
	justify-content: center;
`;

export const VariantTableCell1 = styled.td`
	width: 100px;
	font-size: 18px;
	border-top: 1px solid grey;
	text-align: left;
	padding: 11px 0px;
`;

export const VariantTableCell2 = styled.td`
	width: 200px;
	font-size: 18px;
	border-top: 1px solid grey;
	text-align: center;
`;

export const VariantTableCell3 = styled.td`
	width: 80px;
	font-size: 18px;
	border-top: 1px solid grey;
	text-align: center;
`;

export const VariantTableHeadLeft = styled.th`
	font-size: 20px;
	text-align: left;
`;

export const VariantTableHeadCenter = styled.th`
	font-size: 20px;
	text-align: center;
`;

export const NotCreateFlex = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 40px;
`;

export const ConfirmWrapper = styled.div`
	display: flex;
	justify-content: center;
	gap: 50px;
	margin-top: 20px;
`;

export const ExtraShiftConfirmSpan = styled.span`
	font-size: 36px;
	color: ${Colors.red};
	font-weight: bold;
	text-decoration: underline;
`;

export const ExtraShiftConfirmButtons = styled.div`
	display: flex;
	justify-content: center;
	gap: 50px;
	margin-top: 20px;
`;

export const ItemsErrorTitle = styled.h3`
	max-width: 400px;
	color: ${Colors.red};
	text-align: center;
`;

export const AddressDetails = styled.div`
	border: 1px #010b7760 solid;
	border-radius: 8px;
	margin-bottom: 16px;
	width: fit-content;
	margin-left: 130px;
	padding-bottom: 12px;
`;
